module.exports = __webpack_public_path__ + "static/media/logo.1dace737.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPage/logo.svg
// module id = 75
// module chunks = 1